import React from 'react';
import { useSEO } from '../hooks/useSEO';
import ProductHero from '../components/ProductHero';
import Workflow from '../components/Workflow';

const V2SafeTrace = () => {
  useSEO({
    title: 'SafeTrace | Passive fire protection survey & evidence',
    description: 'SafeTrace provides a structured digital record for passive fire protection, survey, locate, record, photograph, remediate, verify, close. Available independently.',
    path: '/firestopping/safetrace',
  });

  return (
    <div data-testid="v2-safetrace">
      <ProductHero
        eyebrow="SafeTrace"
        title="Firestopping evidence you can trust."
        subtitle="Survey. Locate. Record. Remediate. Verify."
        body={(
          <>
            <p>SafeTrace provides a structured digital record for passive fire protection work from initial survey through remediation and sign-off.</p>
            <p>Capture what was found. Where it was found. The evidence. What action was required. What was completed. And how it was verified.</p>
          </>
        )}
        primary={{ label: 'Explore SafeTrace', to: '/contact' }}
        supportingLine="Available independently or included within the Firestopping Business Dashboard."
        testid="safetrace-hero"
      />

      <section className="py-16 md:py-20 bg-slate-50 border-y border-slate-200">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <p className="text-xs uppercase tracking-[0.22em] text-blue-600 font-semibold mb-4">SafeTrace journey</p>
          <h2 className="text-3xl md:text-4xl font-medium tracking-tight text-slate-900 mb-10">From survey to closed evidence.</h2>
          <Workflow testid="safetrace-workflow" steps={['Survey','Locate','Record','Photograph','Remediate','Verify','Close','Evidence']} />
        </div>
      </section>
    </div>
  );
};

export default V2SafeTrace;
